/**
 * Validates if the given email address is in a valid format
 * @param email - The email address to validate
 * @returns boolean indicating if the email is valid
 */
export const isValidAddress = (email: string): boolean => {
  if (!email) return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
